/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_SkillsInputs */

const en_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const de_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const fr_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const es_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const it_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const nl_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const pl_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const fi_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const da_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

const sv_story_bank_label_skills = /** @type {(inputs: Story_Bank_Label_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills (comma-separated)`)
};

/**
* | output |
* | --- |
* | "Skills (comma-separated)" |
*
* @param {Story_Bank_Label_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_skills = /** @type {((inputs?: Story_Bank_Label_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_skills(inputs)
	if (locale === "fr") return fr_story_bank_label_skills(inputs)
	if (locale === "es") return es_story_bank_label_skills(inputs)
	if (locale === "it") return it_story_bank_label_skills(inputs)
	if (locale === "nl") return nl_story_bank_label_skills(inputs)
	if (locale === "pl") return pl_story_bank_label_skills(inputs)
	if (locale === "fi") return fi_story_bank_label_skills(inputs)
	if (locale === "da") return da_story_bank_label_skills(inputs)
	if (locale === "sv") return sv_story_bank_label_skills(inputs)
	return en_story_bank_label_skills(inputs)
});